import script from "./NuevoReclamo.vue?vue&type=script&setup=true&lang=js"
export * from "./NuevoReclamo.vue?vue&type=script&setup=true&lang=js"

import "./NuevoReclamo.vue?vue&type=style&index=0&id=534fe100&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-534fe100"]])

export default __exports__